import React from "react";
import "./PastEvents.scss";

const PastEvents = () => {
    return (
        <div className="page-placeholder past-events-page">
            <h1>Past Events</h1>
            <p>Coming Soon: Photos from past events organized by year</p>
            <p><em>Content will be added from dropbox folder</em></p>
        </div>
    );
};

export default PastEvents;
